import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
/**
 * `tailwind-merge` has to be told about this package's theme, or it cannot know
 * that `lg:text-h1` and `lg:text-body` are the same property and that one
 * should win. Out of the box it assumes Tailwind's default scale names.
 *
 * The prefix matters just as much: Tailwind 4 applies a prefix as a leading
 * variant, so every class this package writes reads `lg:...`, and the merger
 * has to strip that before it can classify anything.
 */
const twMerge = extendTailwindMerge({
    prefix: "lg",
    extend: {
        classGroups: {
            "font-size": [
                {
                    text: [
                        "eyebrow",
                        "label",
                        "button",
                        "button-sm",
                        "micro",
                        "caption",
                        "body",
                        "body-sm",
                        "lead",
                        "h4",
                        "h3",
                        "h2",
                        "h1",
                        "stat",
                    ],
                },
            ],
            "font-family": [{ font: ["sans", "mono", "label"] }],
            rounded: [{ rounded: ["xs", "sm", "md", "lg", "xl", "pill"] }],
            shadow: [{ shadow: ["float", "card", "panel"] }],
        },
    },
});
/**
 * Compose class names, letting the last conflicting Tailwind utility win.
 *
 * This is the single reason every component takes a `className`: a consumer
 * can pass `lg:rounded-md` to a component whose variant sets `lg:rounded-pill`
 * and get the override, rather than two competing classes and a coin toss on
 * stylesheet order.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map